// main functions
export function toggleFavorite(el) {
    var localFavorites = getFavorites();
    const button = el.dataset.vehicle ? el : el.parentElement;
    var newFavorites = localFavorites
      ? localFavorites.filter((val) => val != button.dataset.vehicle)
      : [];
    const deletedFavorite = button.classList.contains("active")
      ? button.dataset.vehicle
      : null;
    const activeFavorites = document.querySelectorAll(".toggleFavorite.active");
  
    if (!button.dataset.vehicle) {
      return console.error("dataset.vehicle não encontrado");
    }
  
    if (!button.classList.contains("active")) {
      newFavorites.push(button.dataset.vehicle);
    }
  
    button.classList.toggle("active");
    let iconFavoriteChange = button.querySelector('i')
    if(iconFavoriteChange){
      iconFavoriteChange.classList.remove('icon-favorito-vazado')
      iconFavoriteChange.classList.add('icon-favorito-cheio')
    }
    
  
    setFavorites(newFavorites);
    updateModal();
  
    activeFavorites.forEach((item) => {
      if (deletedFavorite && JSON.parse(item.dataset.vehicle).id == JSON.parse(deletedFavorite).id) {
        item.classList.remove("active");
        if(iconFavoriteChange){
          iconFavoriteChange.classList.remove('icon-favorito-cheio')
          iconFavoriteChange.classList.add('icon-favorito-vazado')
        }
      }
    });
  }
  
  export function notificationsFavorites() {
    let favoriteButtons = document.querySelectorAll(".toggleFavorite");
    favoriteButtons.forEach((button) =>
      button.addEventListener("click", function () {
        let addFavorite = document.getElementById("addFavorite");
        let rmvFavorite = document.getElementById("rmvFavorite");
        
        if (button.classList.contains("active")) {
          addFavorite.classList.add("show");
          setNumberOfFavorites();
          setTimeout(function () {
            addFavorite.classList.remove("show");
          }, 2000);
        } else {
          rmvFavorite.classList.add("show");
          setNumberOfFavorites();
          setTimeout(function () {
            rmvFavorite.classList.remove("show");
          }, 2000);
        }
      })
    );
  }
  
  
  export function setNumberOfFavorites() {
    var countFavoriteNumber = document.querySelectorAll(".countFavoriteNumber");
    let storageC = JSON.parse(localStorage.getItem("favorites"));
    countFavoriteNumber.forEach((item) => {
      if (storageC && storageC.length > 0) {
        item.style.display = "block";
        item.textContent = storageC.length;
      } else {
        item.style.display = "none";
      }
    });
  }
  
  function updateModal() {
    var localFavorites = getFavorites();
    if (!localFavorites || !localFavorites.length) {
      setCountFavoritesContent("");
      setNumberOfFavorites();
      return setModalContent(
        '<p class="title-vehicles">Nenhum veículo salvo.</p>'
      );
    }
  
    setModalContent("");
    localFavorites.forEach((item) => {
      modal.forEach((modal) => {
        modal.insertAdjacentHTML("beforeend", getCard(JSON.parse(item)));
      });
    });
  
    var count = localFavorites.length;
    setNumberOfFavorites();
    countFavorites.forEach((modal) => {
      modal.innerHTML = `<p>Veículos favoritos (${count})</p>`;
    });
  
    Array.from(
      document.querySelectorAll(".favorite-card .toggleFavorite")
    ).forEach((el) =>
      el.addEventListener("click", (e) => toggleFavorite(e.target))
    );
  }
  
  function getCard(data) {
    return `<div class="favorite-card">
        <a href="${data.url}">
          <div class="card-img">
            <img class="w-100" src="${data.image}" alt="Foto do veículo">
          </div>
        </a>
        <div class="card-info">
          <h2> ${data.version}</h2>
          <p>${data.name}</p>
          <div class="card-features">
            <div class="car-year">
              <i class="icon-calendario-regular"></i>
              ${data.year_version}/${data.year_model}
            </div>
            <div class="car-km">
              <i class="icon-quilometragem-bold"></i>
              ${data.km}
            </div>
          </div>
          <i class="icon-lixeira toggleFavorite active" data-vehicle='${JSON.stringify(
            data
          )}'></i>
        </div>
      </div>`;
  }
  
  // helpers
  function getFavorites() {
    return JSON.parse(localStorage.getItem("favorites"));
  }
  function setFavorites(favorites) {
    return localStorage.setItem("favorites", JSON.stringify(favorites));
  }
  function hasFavorite(item) {
    return getFavorites() ? getFavorites().includes(item) : false;
  }
  function setModalContent(content) {
    return modal.forEach((modal) => (modal.innerHTML = content));
  }
  function setCountFavoritesContent(content) {
    return countFavorites.forEach((modal) => {
      modal.textContent = content;
    });
  }
  
  export function checkAllFavorites(toggleFavorites) {
    var localFavorites = getFavorites();
    if(localFavorites){
  
      localFavorites.forEach(favorite => {
        toggleFavorites.forEach(item => {
    
          let favoriteCheck = JSON.parse(favorite);
          let buttonData = JSON.parse(item.dataset.vehicle);
          
          if(favoriteCheck.id  == buttonData.id){
            if(!item.classList.contains("active")){
              item.classList.add("active")
            }
          }
        });
      })
    }
  }
  
  // elements
  var modal = document.querySelectorAll(".favoritesModal .modal-body");
  var countFavorites = document.querySelectorAll(
    ".favoritesModal .count-favorites"
  );
  var showFavorites = Array.from(document.querySelectorAll(".showFavorites"));
  var toggleFavorites = Array.from(document.querySelectorAll(".toggleFavorite"));
  var removeAllFavorites = Array.from(
    document.querySelectorAll(".removeAllFavorites")
  );
  
  
  // event listeners
  showFavorites.forEach((el) => el.addEventListener("click", updateModal));
  toggleFavorites.forEach((el) =>
    el.addEventListener("click", (e) => toggleFavorite(e.target))
  );
  toggleFavorites.forEach((el) =>
    hasFavorite(el.dataset.vehicle)
      ? el.classList.add("active")
      : el.classList.remove("active")
  );
  removeAllFavorites.forEach((el) =>
    el.addEventListener("click", () => {
      setFavorites([]);
      updateModal();
    })
  );
  
  notificationsFavorites();
  setNumberOfFavorites();
  checkAllFavorites(toggleFavorites);
  